import React from 'react';

import { StepListProps } from './StepList.types';

import styles from './StepList.module.scss';

export const StepList = ({ align = 'top', counter = 'visible', steps = [] }: StepListProps) => {
  if (!steps.length) {
    return null;
  }

  return (
    <ol className={styles.stepList} data-alignment={align} data-counter={counter}>
      {steps.map((step) => (
        <li key={step.id} className={styles.step}>
          {step.content}
        </li>
      ))}
    </ol>
  );
};
